"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

type PGEligibilityWidgetType = {
  initialize: (id: string, pid: string, apiKey: string, locale: string) => void;
};

type GlobalThisWithPGEligibilityWidget = typeof globalThis & {
  PGEligibilityWidget?: PGEligibilityWidgetType;
};

export type PlusgradeFormClientProperties = {
  locale: string;
  envScriptUrl: string;
  shouldLoadNprdEnvScript: boolean;
  scriptUrl: string;
  apiKey: string;
  pid: string;
};
export const PlusgradeFormClient = ({
  locale,
  envScriptUrl,
  shouldLoadNprdEnvScript,
  scriptUrl,
  apiKey,
  pid,
}: PlusgradeFormClientProperties) => {
  const [areEnvironmentVariablesReady, setAreEnvironmentVariablesReady] =
    useState(shouldLoadNprdEnvScript ? false : true);
  const [isWidgetReady, setIsWidgetReady] = useState(false);

  useEffect(() => {
    const globalThisWithPGEligibilityWidget =
      globalThis as GlobalThisWithPGEligibilityWidget;
    if (
      globalThisWithPGEligibilityWidget.PGEligibilityWidget &&
      typeof globalThisWithPGEligibilityWidget.PGEligibilityWidget
        .initialize === "function" &&
      isWidgetReady &&
      areEnvironmentVariablesReady
    ) {
      globalThisWithPGEligibilityWidget.PGEligibilityWidget.initialize(
        "pg-ew",
        pid,
        apiKey,
        locale,
      );
    }
  }, [pid, apiKey, locale, areEnvironmentVariablesReady, isWidgetReady]);

  return (
    <>
      {envScriptUrl && shouldLoadNprdEnvScript && (
        <Script
          async
          id="__pg_eligibility_widget_env__"
          onLoad={() => {
            setAreEnvironmentVariablesReady(true);
          }}
          src={envScriptUrl}
        />
      )}
      <Script
        async
        id="__pg_eligibility_widget__"
        onLoad={() => {
          setIsWidgetReady(true);
        }}
        src={scriptUrl}
      />
      <div
        className="
          container mx-auto

          [&_.MuiButton-colorCallToAction]:rounded-xl!
          [&_.MuiButton-colorCallToAction]:bg-primary!

          [&_.MuiButton-colorCallToAction:hover]:bg-primary-variant!

          [&_.MuiLink-root]:text-primary!
          [&_.MuiLink-root]:[text-decoration-color:currentColor]!
          [&_.MuiLink-root]:[--Link-underlineColor:currentColor]!

          [&_.MuiTypography-subtitle3-bold]:text-foreground-primary-variant

          [&_label_.MuiTypography-body2-bold]:text-on-surface

          [*+&]:mt-4

          md:[*+&]:mt-6
        "
        data-fs-element="plusgrade"
        id="pg-ew"
      />
    </>
  );
};
